import React from 'react';
import { FaInstagram } from 'react-icons/fa';
import './InstagramButton.css';

const InstagramButton = () => {
  const instagramUrl = 'https://www.instagram.com/skyline_backpackers/';
  
  return (
    <a
      href={instagramUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="instagram-float"
      aria-label="Follow us on Instagram"
    >
      <FaInstagram className="instagram-icon" />
      <span className="instagram-text">Follow Us</span>
    </a>
  );
};

export default InstagramButton;
